import React from "react";
import { matchPath, useLocation } from "react-router-dom";

import { Button, Stack } from "@mui/material";
import { Routes } from "constants/routes";
import { useNavigate } from "hooks";
import { useAccountSelector } from "store";

import { MessagePopper } from "../Message-popper/MessagePopper";

export const Header: React.FC = () => {
  const isSocialEnabled = useAccountSelector()?.allow_social;
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const headerTitle = () => {
    if (matchPath(pathname, Routes.socialProfile)) {
      return (
        <Button
          variant="contained"
          onClick={() => {
            navigate({
              route: "social"
            });
          }}
        >
          Explore Profiles
        </Button>
      );
    }
    return null;
  };

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ padding: "0px 48px 0px 65px" }}>
      {isSocialEnabled && headerTitle()}
      {matchPath(pathname, Routes.socialProfile) && (
        <Stack direction="row" gap="15px" alignItems={"center"}>
          <MessagePopper
            btnTitle="Get advice"
            title="Advice Request"
            subTitle="This will be shares with relevant members in your network"
            placeholder="Include context, timeline, and what feedback you're looking for"
            type="advice"
          />
          <MessagePopper
            btnTitle="Co-invest"
            title="I’m looking to co-invest"
            subTitle="This request will be shared with relevant members in your network"
            placeholder="Include the sectors, geographies, check size,and timeline you're considering"
            type="co-invest"
          />
          <MessagePopper
            btnTitle="Sell"
            title="Sell an Interest"
            subTitle="This message will be visible to relevant members in your network. Do not include confidential information."
            placeholder="Share the position details and target terms"
            type="sell"
          />
        </Stack>
      )}
    </Stack>
  );
};
